import React, { useCallback, useState } from 'react'
import { createFetcher } from '../../../libs/next/api/jsonApiHandler'
import type { API } from '../../../pages/api/forms/[handler]'
import { Translation, useTranslate } from '../../contexts/TranslationContext'
import style from '../layout/Footer.module.sass'

const api = createFetcher<API>('/api/forms/[handler]')

export const FooterNewsletterForm = React.memo(function FooterNewsletterForm() {
	const [isSubscribed, setIsSubscribed] = useState(false)
	const [email, setEmail] = useState<string | null>(null)

	const clearForm = useCallback(() => {
		setEmail('')
	}, [])

	const translate = useTranslate()

	return (
		<form
			action=""
			method="POST"
			onSubmit={async (e) => {
				e.preventDefault()
				if (email) {
					try {
						await api('newsletterInvite', { email: email })
						setIsSubscribed(true)
						clearForm()
					} catch (err) {
						console.log('error', err)
					}
				}
			}}
		>
			<fieldset>
				<div className={style.inputWrapper}>
					<input
						className={style.input}
						placeholder={translate('email.placeholder')}
						name="email"
						type="email"
						required
						value={email ?? ''}
						onChange={(e) => setEmail(e?.target.value)}
					/>
				</div>
				<div className={style.buttonWrapper}>
					{isSubscribed ? (
						<div className={style.confirmationMessage}>
							<Translation tr="footer.column.second.confirmationMessage" />
						</div>
					) : (
						<button className={style.buttonNewsletter} type="submit">
							<Translation tr="footer.column.second.subscribe" />
						</button>
					)}
				</div>
			</fieldset>
		</form>
	)
})
